import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const ShareButton = styled.button`
  background-color: transparent;
  color: #ff992d;

  padding: 0;

  border: none;

  &:hover:enabled {
    cursor: pointer;
  }
`

export const OptionsContainer = styled.div`
  margin-bottom: 1rem;

  display: flex;
  justify-content: space-between;
  align-items: center;

  flex-wrap: wrap;

  gap: 1rem;
`
